import React from 'react';
import './loader.css';
import spinner from '../../../assets/Loader/CM_loader.gif';
import spinnerBlack from '../../../assets/Gear-blk.gif';
import spinnerDark from '../../../assets/Loader/CM_loader_dark.png';
import { useTheme } from '../../../context/ThemeContext';

const Loader = (props) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const imgSrc = isDark ? spinnerDark : (props.color === 'black' ? spinnerBlack : spinner);

  return (
    <div className={`loaderWrapper ${isDark ? 'loaderWrapper--dark' : ''}`}>
      <div className="loader">
        <img src={imgSrc} alt="loading" />
        <p className="mt-4">Loading...</p>
      </div>
    </div>
  );
};

export default Loader;
